import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var toggleConnectBasicWindow = mutatorAction('toggleConnectBasicWindow', function (state) {
    var store = connectedAccountsStore();
    store.dialogWindowState.connectBasicOpen = state.connectBasicOpen;
});
//# sourceMappingURL=toggleconnectBasicWindow.js.map